import { useMemo } from "react";
import {
  formatNumber,
  normalizeHeatMap,
} from "../utils/machineDashboardUtils";

function getCellClass(status, percentage) {
  const normalized = String(status || "").toUpperCase();

  if (normalized === "HIGH") return "high";
  if (normalized === "MEDIUM") return "medium";
  if (normalized === "LOW") return "low";
  if (normalized === "NO_DATA") return "no-data";

  const value = Number(percentage || 0);

  if (value >= 75) return "high";
  if (value >= 40) return "medium";
  if (value > 0) return "low";

  return "no-data";
}

function MachineHeatMap({ data }) {
  const normalizedData = useMemo(() => {
    return normalizeHeatMap(data);
  }, [data]);

  const machines = normalizedData?.machines || [];
  const hours = normalizedData?.hours || [];

  if (!machines.length) {
    return (
      <div className="mud-empty-state">
        No heat map information available.
      </div>
    );
  }

  return (
    <div className="mud-heatmap">

      <div className="mud-heatmap__legend">
        <span>
          <i className="high" /> High 75%+
        </span>

        <span>
          <i className="medium" /> Medium 40-74%
        </span>

        <span>
          <i className="low" /> Low 0-39%
        </span>

        <span>
          <i className="no-data" /> No Runtime
        </span>
      </div>

      <div className="mud-heatmap__scroll">
        <div
          className="mud-heatmap__grid"
          style={{
            gridTemplateColumns: `200px repeat(${hours.length}, minmax(42px, 1fr))`,
          }}
        >
          {/* HEADER */}
          <div className="mud-heatmap__corner">
            Machine
          </div>

          {hours.map((hour) => (
            <div
              className="mud-heatmap__hour"
              key={`header-${hour.hour}`}
              title={hour.label}
            >
              {String(hour.hour).padStart(2, "0")}
            </div>
          ))}

          {/* MACHINE ROWS */}
          {machines.map((machine, machineIndex) => {
            const hourlyData = Array.isArray(machine?.hours)
              ? machine.hours
              : [];

            return (
              <div
                className="mud-heatmap__row"
                key={
                  machine?.machineCode ||
                  `machine-${machineIndex}`
                }
                style={{
                  gridColumn: `1 / span ${hours.length + 1}`,
                  gridTemplateColumns: `200px repeat(${hours.length}, minmax(42px, 1fr))`,
                }}
              >
                {/* MACHINE INFORMATION */}
                <div className="mud-heatmap__machine">
                  <strong>
                    {machine?.machineCode || "-"}
                  </strong>

                  {/* <span>
                    {machine?.machineName || "-"}
                  </span> */}

                  <small>
                    {machine?.deptName || "-"}
                    {/* {machine?.deptCode
                      ? ` (${machine.deptCode})`
                      : ""} */}
                  </small>
                </div>

                {/* HOURLY CELLS */}
                {hours.map((headerHour) => {
                  const hourData = hourlyData.find(
                    (item) =>
                      Number(item?.hour) ===
                      Number(headerHour?.hour),
                  );

                  const utilization = Number(
                    hourData?.utilizationPercentage || 0,
                  );

                  return (
                    <div
                      key={`${machine?.machineCode}-${headerHour.hour}`}
                      className={`mud-heatmap__cell ${getCellClass(
                        hourData?.status,
                        utilization,
                      )}`}
                      title={[
                        `Machine: ${machine?.machineCode || "-"}`,
                        `Name: ${machine?.machineName || "-"}`,
                        `Department: ${machine?.deptName || "-"}`,
                        `Hour: ${hourData?.label || headerHour?.label || "-"}`,
                        `Status: ${hourData?.status || "NO_DATA"}`,
                        `Utilization: ${formatNumber(utilization, 2)}%`,
                        `Runtime: ${formatNumber(
                          hourData?.runningMinutes,
                          2,
                        )} min`,
                        `Runtime Seconds: ${formatNumber(
                          hourData?.runningSeconds,
                          2,
                        )} sec`,
                      ].join("\n")}
                    >
                      {utilization > 0
                        ? Math.round(utilization)
                        : ""}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default MachineHeatMap;